module.exports = __webpack_public_path__ + "0ff5f5b97f03beea045667ded2ab8883.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-skate.png
// module id = 3429
// module chunks = 0